import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "src/components/ui/table";
import { useGetPanelsQuery } from "../../endpoints/panel.endpoints";
import { Panel } from "../../types/panel.types";
import { formatDateTime } from "src/pages/billing/utils/billing-utils";
import { Client } from "src/pages/client-management/types/client.types";
import { Lock } from "lucide-react";

interface PanelTableProps {
  clients: Client[];
  onOpenChange: (panel?: Panel) => void;
}

const PanelTable: React.FC<PanelTableProps> = ({ clients, onOpenChange }) => {

  const { data: panels, isLoading: isLoadingPanels } = useGetPanelsQuery();

  return (
    <>
      <div className="w-full bg-white rounded-lg shadow-md overflow-hidden mt-4">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="pl-4" />
              <TableHead>
                Name
              </TableHead>
              <TableHead>
                Client
              </TableHead>
              <TableHead>
                Created At
              </TableHead>
              <TableHead>
                Updated At
              </TableHead>
              <TableHead>
                Dimensions
              </TableHead>
              <TableHead>
                Users
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {panels?.map((panel) => (
              <TableRow
                key={panel.id}
                className="cursor-pointer hover:bg-gray-200"
                onClick={() => onOpenChange(panel)}
              >
                <TableCell className="py-4 pl-4 w-fit min-w-[20px] pr-0">
                  {panel.locked && (<Lock className="w-4 h-4" />)}
                </TableCell>
                <TableCell className="py-4">
                  {panel.name}
                </TableCell>
                <TableCell>
                  {clients.find((client) => client.ext_client_id === panel.client)?.title || 'N/A'}
                </TableCell>
                <TableCell>
                  {formatDateTime(panel.created_at)}
                </TableCell>
                <TableCell>
                  {formatDateTime(panel.updated_at)}
                </TableCell>
                <TableCell className="">
                  {panel.fields.filter((field) => field.status === 'active').length}
                </TableCell>
                <TableCell className="">
                  {panel.panelists || 0}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </>
  );
};

export default PanelTable;
